import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    _createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10 14.535a4.008 4.008 0 014 0M2 15l.701-7.015c.027-.266.04-.399.06-.513A3 3 0 015.485 5.01C5.599 5 5.733 5 6 5m16 10l-.701-7.015c-.027-.266-.04-.399-.06-.513a3 3 0 00-2.723-2.463C18.402 5 18.268 5 18 5m-9.172 7.172a4 4 0 11-5.656 5.656 4 4 0 015.656-5.656zm12 0a4 4 0 11-5.656 5.656 4 4 0 015.656-5.656z"
    })
  ]))
}